import dotProp from 'dot-prop-immutable'
import { connect } from 'react-redux'
import { movingSet, stopMovingSet } from "../../actions/project/draggable";
import DraggableProduct from './../../components/DraggableProduct'

const mapStateToProps = state => ({
  perMeter: dotProp.get(state, 'project.background.perMeter', 1000),
  isResizing: dotProp.get(state, 'products.isResizing', false),
  crop: dotProp.get(state, 'project.background.crop', { width: 100, height: 100 } ),
  dim: dotProp.get(state, 'project.dim', { width: 100, height: 100 }),
})

const mapDispatchToProps = dispatch => ({
  onStopMove: (index, position) => dispatch(stopMovingSet(index, position)),
  onMove: (index, position) => dispatch(movingSet(index, position)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DraggableProduct)



// WEBPACK FOOTER //
// ./src/containers/DraggableSet/index.js